<template>
    <div>
        <nmindex v-if="$siteName === 'nm'"></nmindex>
        <otherindex v-else></otherindex>
    </div>
</template>

<script>
import nmindex from './nmindex';
import otherindex from './otherindex.vue';
export default {
    components: {
        nmindex,
        otherindex},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
</style>
